import {
  MASTER_THIRD_PARTY_PRICING_LIST,
  MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_LIST_FAILURE,
  MASTER_THIRD_PARTY_PRICING_CREATE,
  MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE,
  MASTER_THIRD_PARTY_PRICING_UPDATE,
  MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE,
  MASTER_THIRD_PARTY_PRICING_DELETE,
  MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS,
  MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  // LIST
  masterThirdPartyPricingList: [],
  masterThirdPartyPricingListLoading: false,
  masterThirdPartyPricingListError: null,

  // CREATE
  masterThirdPartyPricingCreate: {},
  masterThirdPartyPricingCreateLoading: false,
  masterThirdPartyPricingCreateError: null,

  // UPDATE
  masterThirdPartyPricingUpdate: {},
  masterThirdPartyPricingUpdateLoading: false,
  masterThirdPartyPricingUpdateError: null,

  // DELETE
  masterThirdPartyPricingDelete: {},
  masterThirdPartyPricingDeleteLoading: false,
  masterThirdPartyPricingDeleteError: null,
};

const masterThirdPartyPricingReducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case MASTER_THIRD_PARTY_PRICING_LIST:
      return {
        ...state,
        masterThirdPartyPricingListLoading: true,
        masterThirdPartyPricingListError: null,
      };

    case MASTER_THIRD_PARTY_PRICING_LIST_SUCCESS:
      return {
        ...state,
        masterThirdPartyPricingList: action.payload,
        masterThirdPartyPricingListLoading: false,
      };

    case MASTER_THIRD_PARTY_PRICING_LIST_FAILURE:
      return {
        ...state,
        masterThirdPartyPricingListLoading: false,
        masterThirdPartyPricingListError: action.payload,
      };

    // CREATE
    case MASTER_THIRD_PARTY_PRICING_CREATE:
      return {
        ...state,
        masterThirdPartyPricingCreateLoading: true,
        masterThirdPartyPricingCreateError: null,
      };

    case MASTER_THIRD_PARTY_PRICING_CREATE_SUCCESS:
      return {
        ...state,
        masterThirdPartyPricingCreate: action.payload,
        masterThirdPartyPricingCreateLoading: false,
      };

    case MASTER_THIRD_PARTY_PRICING_CREATE_FAILURE:
      return {
        ...state,
        masterThirdPartyPricingCreateLoading: false,
        masterThirdPartyPricingCreateError: action.payload,
      };

    // UPDATE
    case MASTER_THIRD_PARTY_PRICING_UPDATE:
      return {
        ...state,
        masterThirdPartyPricingUpdateLoading: true,
        masterThirdPartyPricingUpdateError: null,
      };

    case MASTER_THIRD_PARTY_PRICING_UPDATE_SUCCESS:
      return {
        ...state,
        masterThirdPartyPricingUpdate: action.payload,
        masterThirdPartyPricingUpdateLoading: false,
      };

    case MASTER_THIRD_PARTY_PRICING_UPDATE_FAILURE:
      return {
        ...state,
        masterThirdPartyPricingUpdateLoading: false,
        masterThirdPartyPricingUpdateError: action.payload,
      };

    // DELETE
    case MASTER_THIRD_PARTY_PRICING_DELETE:
      return {
        ...state,
        masterThirdPartyPricingDeleteLoading: true,
        masterThirdPartyPricingDeleteError: null,
      };

    case MASTER_THIRD_PARTY_PRICING_DELETE_SUCCESS:
      return {
        ...state,
        masterThirdPartyPricingDelete: action.payload,
        masterThirdPartyPricingDeleteLoading: false,
      };

    case MASTER_THIRD_PARTY_PRICING_DELETE_FAILURE:
      return {
        ...state,
        masterThirdPartyPricingDeleteLoading: false,
        masterThirdPartyPricingDeleteError: action.payload,
      };

    default:
      return state;
  }
};

export default masterThirdPartyPricingReducer;
